"use client";

import { NextIntlClientProvider, IntlErrorCode } from "next-intl";
import type { ReactNode } from "react";

// Wrapper: JANGAN pernah menjatuhkan aplikasi gara-gara satu key terjemahan.
export function IntlProviderClient({
  locale,
  messages,
  children,
}: {
  locale: string;
  messages: Record<string, unknown>;
  children: ReactNode;
}) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      onError={(error) => {
        if (error.code === IntlErrorCode.MISSING_MESSAGE) return;
        // eslint-disable-next-line no-console
        console.error(error);
      }}
      getMessageFallback={({ namespace, key }) =>
        [namespace, key].filter(Boolean).join(".")
      }
    >
      {children}
    </NextIntlClientProvider>
  );
}
